// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutCreate_container_2ec-k","main":"LayoutCreate_main_11hXa"};